module.exports =  require('./lib/mediaquery');




//////////////////
// WEBPACK FOOTER
// ./~/mediaquery/index.js
// module id = 195
// module chunks = 0